import { faGithub, faGooglePlay } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { flutter, react } from "../data/frameworks";

import { ProjectModel } from "../models/projectModel";
import { formatDate } from "../utils/formatDate";
import { generateRoute } from "../utils/generateRoute";
import { ScaledImage } from "./scaledImage";

interface Props {
  project: ProjectModel;
}

const ProjectWidgetRow = ({ project }: Props) => {
  var baseUrl = generateRoute(project.category);
  const createdDate = formatDate(project.createdDate);
  const latestUpdateDate = formatDate(project.latestUpdate);

  const frameworkIconPath = project.framework.name === flutter.name || project.framework.name === react.name
    ? `/assets/icons/${project.framework.svg}`
    : `/assets/icons/${project.framework.icon}`;

  return (
    <Link to={`${baseUrl}/${project.key}`}>
      <div className="p-2 sm:p-2 bg-cardColor hover:bg-cardHoverColor w-full rounded-xl my-4">
        <div className="inline-flex flex-row w-full gap-2  justify-between items-center">
          <div className="">
            <ScaledImage
              category={project.category}
              imagePath={project.coverImage}
              isRowCover={true}
              alt={project.coverImage}
              index={0}
            />
          </div>
          <div className="inline-flex flex-col flex-auto gap-3 justify-center px-4">
            <h3>{project.title}</h3>

            <span className=" h-full ">{project.description}</span>

            <div className="inline-flex flex-col">
              <div className="inline-flex flex-col sm:flex-row sm:gap-2">
                <span className="font-medium">Category: </span>
                <div> {project.category.name}</div>
              </div>

              <div className="inline-flex flex-col sm:flex-row sm:gap-2">
                <span className="font-medium">Framework: </span>
                <div> {project.framework.name}</div>
              </div>

              {project.url?.map((e) =>
                e.includes("github") ? (
                  <div
                    key={e}
                    className="inline-flex flex-col sm:flex-row sm:gap-2"
                  >
                    <span className="font-medium">Github Repo: </span>
                    <div> {e.replace("https://github.com/", "")}</div>
                  </div>
                ) : null
              )}
            </div>

            <hr className="py-2 border-gray-300" />
            <div className="inline-flex flex-row justify-between w-full items-end">
              <div className="inline-flex flex-col sm:flex-row sm:gap-2">
                <span className="font-medium">
                  {latestUpdateDate !== createdDate
                    ? "Latest Update:"
                    : "Created Date: "}
                </span>
                <div>
                  {latestUpdateDate !== createdDate
                    ? latestUpdateDate
                    : createdDate}
                </div>
              </div>

              <div className="inline-flex flex-row gap-3 items-center">
                <div
                  className={`${
                    project.framework.name === react.name ? "bg-primary rounded-md" : ""
                  } p-1`}
                >
                  <img
                    src={frameworkIconPath}
                    className="h-6"
                    alt={project.framework.name}
                  />
                </div>

                {project.url &&
                  project.url.map((e) =>
                    e.includes("play.google") ? (
                      <span key={e} className="text-green-900 text-2xl">
                        <FontAwesomeIcon icon={faGooglePlay} />
                      </span>
                    ) : e.includes("github") ? (
                      <span key={e} className="text-black text-2xl">
                        <FontAwesomeIcon icon={faGithub} />
                      </span>
                    ) : null
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProjectWidgetRow;
